export const INTERNAL_DATE_FORMAT = 'MM/dd/yyyy';
export const EXTERNAL_DATE_FORMAT = 'yyyy-MM-DD';
